var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "main_app" } },
    [
      _c(
        "div",
        { staticClass: "main" },
        [
          !_vm.checkout ? _c("head-block") : _vm._e(),
          _vm._v(" "),
          _c("router-view")
        ],
        1
      ),
      _vm._v(" "),
      _c("foot-block"),
      _vm._v(" "),
      _vm.navi ? _c("navi") : _vm._e(),
      _vm._v(" "),
      _c("coockies-subs"),
      _vm._v(" "),
      _vm.preload ? _c("preloader") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "preload-btn text-center" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-green small",
            on: { click: _vm.startPreload }
          },
          [_vm._v("preload")]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }